module.exports = __webpack_public_path__ + "static/stephen-photo-dc88d8f78250846b04a4d669e1b03dfd.jpg";